import { Button, Alert } from "react-bootstrap";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toggleActivation } from "../../../store/actions/clientsAction";
import Popup from "../../common/modal/Popup";
import Loader from "../../common/loader/Loader";
const ToggelActivatateClientPopup = ({
  toggleActivateRec,
  toggleActivateStatus,
  onHide,
  toggleActivateModalShow,
  setToggleActivateModalShow,
}) => {
  
  const dispatch = useDispatch();
  const { error: apiError, isLoader } = useSelector((state) => state.clients);

  const submitHandler = () => {
    return dispatch(
      toggleActivation({
        clientId: toggleActivateRec,
      })
    ).then(() => {
    //   onHide();
    //   setToggleActivateModalShow(false);
    });
  };
  return (
    <>
      <Popup
        onHide={() => onHide()}
        size="md"
        show={toggleActivateModalShow}
        title={
          toggleActivateStatus === "ACTIVE"
            ? "Deactivate Admin"
            : "Activate Admin"
        }
        footer={
          <>
          {apiError ? (
            <>
             <Button
             variant="outline-secondary model-btn"
             className="me-4"
             onClick={(e) => onHide()}
           >
             Ok
           </Button>
           </>
          ):(
            <>
            <Button
              variant="outline-secondary model-btn"
              className="me-4"
              onClick={(e) => onHide()}
            >
              Cancel
            </Button>
            <Button
              className="btn-primary model-btn"
              onClick={(e) => submitHandler()}
            >
              Confirm
            </Button>
            </>
          )}
            
          </>
        }
      >
        {isLoader && <Loader />}
        {apiError && (
          <Alert variant={"danger"}>
            {apiError?.message || "Access denied! Please try again"}
          </Alert>
        )}
        <div style={{ textAlign: "center" }}>
        {apiError ? <></>:<>
        {toggleActivateStatus === "ACTIVE"
            ? "Are you sure you want to deactivate this admin?"
            : "Are you sure you want to activate this admin?"}
        </>}
          
        </div>
      </Popup>
    </>
  );
};

export default ToggelActivatateClientPopup;
